import { useMediaQuery } from './useMediaQuery';

export const useIsMobile = () => {
  return { isMobile: useMediaQuery('(max-width:800px)') };
};
